import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-create-caso-uso',
  templateUrl: './dialog-create-caso-uso.component.html',
  styleUrls: ['./dialog-create-caso-uso.component.css']
})
export class DialogCreateCasoUsoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
